// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".styles-errorBox-DoU5K {\n\tmargin: 10px;\n}", ""]);
// Exports
exports.locals = {
	"errorBox": "styles-errorBox-DoU5K"
};
module.exports = exports;
